"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_BASE = "/image/new-version/fabrication/metal-stamping/Surface-Finishes";

const FINISH_CARDS = [
	{ keyPrefix: "surfaceFinishesCard1", image: `${IMAGE_BASE}/electroplating.webp` },
	{ keyPrefix: "surfaceFinishesCard2", image: `${IMAGE_BASE}/powder-coating.webp` },
	{ keyPrefix: "surfaceFinishesCard3", image: `${IMAGE_BASE}/anodizing.webp` },
	{ keyPrefix: "surfaceFinishesCard4", image: `${IMAGE_BASE}/polishing-brushing.webp` },
	{ keyPrefix: "surfaceFinishesCard5", image: `${IMAGE_BASE}/passivation.webp` },
	{ keyPrefix: "surfaceFinishesCard6", image: `${IMAGE_BASE}/galvanizing.webp` },
] as const;

const MORE_HREF = "/surface-finishing";

export default function MetalStampingSurfaceFinishes() {
	const t = useTranslations("new-stamping");

	return (
		<section className="bg-[#ededed] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 flex flex-col gap-4 sm:mb-8 md:mb-10 md:items-start md:justify-between md:gap-8 lg:mb-12 lg:gap-12">
					<h2 className="shrink-0 text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("surfaceFinishesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:min-w-0 md:flex-1 md:text-base lg:max-w-[600px]">
						{t("surfaceFinishesDesc")}
					</p>
				</header>

				<div className="overflow-hidden border border-[#d2d2d2]">
					<div className="grid grid-cols-1 lg:grid-cols-3">
						{FINISH_CARDS.map((card) => (
							<article
								key={card.keyPrefix}
								className="border-b border-[#d2d2d2] bg-[#f3f3f3] p-6 last:border-b-0 sm:p-7 md:p-8 lg:border-b-0 lg:border-r lg:[&:nth-child(-n+3)]:border-b lg:[&:nth-child(3n)]:border-r-0"
							>
								<h3 className="mb-4 text-lg font-bold text-black sm:mb-5 sm:text-xl md:text-2xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<div className="relative mx-auto mb-4 aspect-[4/2] w-full max-w-md overflow-hidden bg-white sm:mb-5">
									<Image
										src={card.image}
										alt={t(`${card.keyPrefix}Alt`)}
										fill
										className="object-contain"
										sizes="(max-width: 1024px) 100vw, 33vw"
									/>
								</div>
								<p className="text-sm leading-relaxed text-black md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</article>
						))}
					</div>
				</div>

				<div className="mt-8 flex justify-center sm:mt-10 md:mt-12">
					<Link
						href={MORE_HREF}
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("surfaceFinishesMoreCta")}
					</Link>
				</div>
			</div>
		</section>
	);
}
